module.exports = __webpack_public_path__ + "media/images/icon-delete@3x-2f31fdf1fb74207ec896aa1652b59a6f.png";